const canonical = value => Array.isArray(value) ? value.map(canonical)
    : value && typeof value === 'object' ? Object.fromEntries(Object.keys(value).sort().filter(key=>value[key]!==undefined).map(key=>[key,canonical(value[key])])) : value
export const sameEdit = (a:unknown,b:unknown) => JSON.stringify(canonical(a))===JSON.stringify(canonical(b))

// Compare the actual initialized editor values, keeping unchanged defaults and
// someone else's map entries out of the save. New records retain their defaults.
export function editPatch(draft:any, baseline:any, {viewer, fresh=false, pair=false}:{viewer?:string,fresh?:boolean,pair?:boolean}={}) {
    const result:any={}
    for(const [key,value]of Object.entries(draft)) {
        if(['id','user','users','public','private','group','quiz'].includes(key))continue
        if(fresh || !sameEdit(value,baseline?.[key]))result[key]=value
    }
    if(draft.id)result.id=draft.id
    if(Array.isArray(draft.users)) {
        if(pair || fresh || !sameEdit(draft.users,baseline?.users))result.users=draft.users
    }
    for(const field of ['public','private','group'])if(Object.hasOwn(draft[field]||{},viewer)) {
        const value=draft[field][viewer]
        if(fresh || !sameEdit(value,baseline?.[field]?.[viewer]))result[field]={[viewer]:value}
    }
    if(Object.hasOwn(draft.quiz||{},viewer)) {
        const own=draft.quiz[viewer]||{}, old=baseline?.quiz?.[viewer]||{}
        const changed=Object.fromEntries(Object.entries(own).filter(([key,value])=>fresh || !sameEdit(value,old[key])))
        if(Object.keys(changed).length){result.quiz={[viewer]:changed};result.quiz_patch=true}
    }
    return result
}
